import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './class_SecurityModal';
import { useState } from 'react';

const WritingModule = ({ module, moduleIndex, expandedModules, toggleModule, expandedClasses, toggleClass, expandedSubClasses, toggleSubClass, expandedSubSubClasses, toggleSubSubClass }) => {
    const navigate = useNavigate();

    // ক্লাস ইনডেক্স থেকে env key map
    const classKeyMap = [
        'WRT19_INTRO', 'WRT20_LINE', 'WRT21_BAR', 'WRT22_PIE', 'WRT23_TABLE', 'WRT24_COMBO', 'WRT25_DIAGRAM', 'WRT26_MAP', 'WRT27_ESSAY', 'WRT28_ADVDIS', 'WRT29_DISCUSS', 'WRT30_2PART'
    ];

    // Password modal state
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingClass, setPendingClass] = useState(null);
    const [pendingClassName, setPendingClassName] = useState('');

    const handleClassClick = (moduleIdx, classIdx, className) => {
        setPendingClass({ moduleIdx, classIdx });
        setPendingClassName(className);
        setModalOpen(true);
    };

    const handlePasswordSuccess = () => {
        if (pendingClass) {
            toggleClass(pendingClass.moduleIdx, pendingClass.classIdx);
        }
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    return (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {/* Module Header */}
            <div
                onClick={() => toggleModule(moduleIndex)}
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition"
            >
                <h2 className="text-xl font-semibold text-[#001670]">{module.name}</h2>
                {expandedModules[moduleIndex] ? (
                    <FaChevronUp className="text-[#001670]" />
                ) : (
                    <FaChevronDown className="text-[#001670]" />
                )}
            </div>

            {/* Expanded Module Content */}
            {expandedModules[moduleIndex] && (
                <div className="px-6 pb-4 space-y-2">
                    {module.classes.map((classItem, classIndex) => {
                        const subKey = `${moduleIndex}-${classIndex}`;
                        // Password-protected class click
                        const classHeader = (header, onClick) => (
                            <div
                                className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                onClick={onClick}
                            >
                                <h3 className="font-medium text-[#001670]">{header}</h3>
                                {expandedClasses[subKey] ? (
                                    <FaChevronUp className="text-[#001670]" />
                                ) : (
                                    <FaChevronDown className="text-[#001670]" />
                                )}
                            </div>
                        );
                        if (classIndex === 1) {
                            // Class 20: Task 01 - Line Charts
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 20 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 20 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Line Charts (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Line Charts</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        {/* Practice 1 (Dynamic) */}
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-line-charts', {
                                                                state: { target: 'practice-01-dynamic' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01 (Dynamic)</span>
                                                        </div>
                                                        {/* Practice 2 (Dynamic) */}
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-line-charts', {
                                                                state: { target: 'practice-02-dynamic' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 02 (Dynamic)</span>
                                                        </div>
                                                        {/* Practice 3 (Dynamic) */}
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-line-charts', {
                                                                state: { target: 'practice-03-dynamic' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 03 (Dynamic)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 2) {
                            // Class 21: Task 01 - Bar Charts
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 21 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 21 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Bar Charts (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Bar Charts</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Static Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Static Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-bar-charts', {
                                                                            state: { target: 'practice-01-static' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-bar-charts', {
                                                                            state: { target: 'practice-02-static' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 02</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Dynamic Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Dynamic Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-bar-charts', {
                                                                            state: { target: 'practice-01-dynamic' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-bar-charts', {
                                                                            state: { target: 'practice-02-dynamic' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 02</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 3) {
                            // Class 22: Task 01 - Pie Charts
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 22 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 22 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Pie Charts (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Pie Charts</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Static Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Static Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-pie-charts', {
                                                                            state: { target: 'practice-01-static' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Dynamic Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Dynamic Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-pie-charts', {
                                                                            state: { target: 'practice-01-dynamic' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 4) {
                            // Class 23: Task 01 - Table Charts
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 23 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 23 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Table Charts (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Table Charts</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Static Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Static Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-table-charts', {
                                                                            state: { target: 'practice-01-static' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Dynamic Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Dynamic Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-table-charts', {
                                                                            state: { target: 'practice-01-dynamic' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 5) {
                            // Class 24: Task 01 - Combined Charts
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 24 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 24 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Combined Charts (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Combined Charts</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Line and Bar Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Line and Bar Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-combined-charts', {
                                                                            state: { target: 'practice-01-line-bar' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Table and Pie Charts */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Table and Pie Charts</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-combined-charts', {
                                                                            state: { target: 'practice-01-table-pie' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 6) {
                            // Class 25: Task 01 - Diagrams
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 25 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 25 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Diagrams (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Diagrams</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Man-made Process */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Man-made Process</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-diagrams', {
                                                                            state: { target: 'practice-01-manmade' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Natural Process */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Natural Process</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-diagrams', {
                                                                            state: { target: 'practice-01-natural' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-diagrams', {
                                                                            state: { target: 'practice-02-natural' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 02</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 7) {
                            // Class 26: Task 01 - Maps
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 26 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 26 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practice on Maps (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practice on Maps</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Past and Present */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Past and Present</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-maps', {
                                                                            state: { target: 'practice-01-past-present' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Present and Future */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Present and Future</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/writing-maps', {
                                                                            state: { target: 'practice-01-present-future' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Practice 01</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 8) {
                            // Class 27: Task 02 - Cause-Problem-Solution Essays
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 27 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 27 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practices (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-essays', {
                                                                state: { target: 'practice-01-causes-solutions' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01: Causes and Solutions</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-essays', {
                                                                state: { target: 'practice-02-problems-solutions' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 02: Problems and Solutions</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-essays', {
                                                                state: { target: 'practice-03-causes-problems' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 03: Causes and Problems</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 9) {
                            // Class 28: Task 02 - Advantages and Disadvantages Essays
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 28 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 28 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practices (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-advantages-disadvantages', {
                                                                state: { target: 'practice-01-advantages-disadvantages' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01: Advantages and Disadvantages</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-advantages-disadvantages', {
                                                                state: { target: 'practice-02-advantages-disadvantages' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 02: Advantages and Disadvantages</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 10) {
                            // Class 29: Task 02 - Discussion Essays
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 29 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 29 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practices (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-discussion', {
                                                                state: { target: 'practice-01-discuss-both-views' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01: Discuss Both Views</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-discussion', {
                                                                state: { target: 'practice-02-agree-disagree' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 02: Agree or Disagree</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 11) {
                            // Class 30: Task 02 - Two-Part Question Essays
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 30 Header */}
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {/* Class 30 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture - Not Clickable */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Writing)</span>
                                            </div>
                                            {/* 2. Guided Practices (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/writing-task2-two-part', {
                                                                state: { target: 'practice-01-two-part' }
                                                            })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01: Two-Part Question</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else {
                            // All other classes in Writing Module
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {classHeader(classItem.name, () => handleClassClick(moduleIndex, classIndex, classItem.name))}
                                    {classItem.subClasses && expandedClasses[`${moduleIndex}-${classIndex}`] && (
                                        <div className="px-4 py-2 space-y-2">
                                            {classItem.subClasses.map((subClass, subIndex) => (
                                                <div key={subIndex} className="border rounded-md">
                                                    <div className="px-4 py-3 bg-gray-50 text-[#001670] font-medium">
                                                        {subClass}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    })}
                    <PasswordModal
                        isOpen={modalOpen}
                        onSubmit={handlePasswordSuccess}
                        onClose={handleModalClose}
                        classKey={classKeyMap[pendingClass?.classIdx]}
                        className={pendingClassName}
                    />
                </div>
            )}
        </div>
    );
};

export default WritingModule; 